<template>
  <div id="payout-value" class="page-container">
    <el-tabs v-model="activeName" type="card">
      <template v-for="(item,index) in componentConfig">
        <el-tab-pane :key="index" :label="item.label" :name="item.compName">
          <component :is="activeName" :key="activeName" />
        </el-tab-pane>
      </template>
    </el-tabs>

  </div>
</template>

<script>

export default {
  name: 'Payout_Approval',
  components: {
    LargeValuePaymentStep: () => import('./components/LargeValuePaymentStep.vue'),
    StandardValuePaymentStep: () => import('./components/StandardValuePaymentStep.vue')
  },
  data() {
    return {
      activeName: 'StandardValuePaymentStep'
    }
  },
  computed: {

    componentConfig() {
      const list = []
      if (this.$store.getters.isHasAuth('AUTH_CODE_SYS_ADM')) {
        list.push({ compName: 'StandardValuePaymentStep', label: this.$t('menu.online_payout') })
      }
      if (['PH', 'TH'].includes(this.$store.getters.curCountry.country_code)) {
        if (this.$store.getters.isHasAuth('AUTH_CODE_SYS_ADM')) {
          list.push({ compName: 'LargeValuePaymentStep', label: this.$t('menu.large_value_payment') })
        }
      }
      return list
    }
  },
  created() {
    if (!this.$store.getters.isHasAuth('AUTH_CODE_SYS_ADM')) {
      this.activeName = 'LargeValuePaymentStep'
    }
  }
}
</script>

<style scoped>
#payout-value ::v-deep .el-tabs__header.is-top{
  width: calc(100% - 90px);
  position: absolute;
  top: 115px;
  left: 46px;
}

</style>
